import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  standalone: false,
  selector: "formly-field-datepicker",
  templateUrl: "./datepicker.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFieldDatepicker extends FieldType<FieldTypeConfig> {

  override defaultOptions = {
    props: {
      clearButton: false,
    },
  };

  onChange(value: Date): void {
    if (this.props.change) {
      this.props.change(this.field, value);
    }
  }

}
